export const imageObj = {
  '智慧林草': {
    video: require('../../assets/img/solution/zhlc.mp4'),
    shorthand: 'SFGS',
    
    points: [
      require('../../assets/img/solution/points/zhlc-1.png'),
      require('../../assets/img/solution/points/zhlc-2.png'),
      require('../../assets/img/solution/points/zhlc-3.png'),
      require('../../assets/img/solution/points/zhlc-4.png'),
    ],
    cases: {
      "某地区林火高风险区和隐患点监测平台": require('../../assets/img/solution/zhlc-1.png'),
      "某地区森林火灾风险区网格化建设平台": require('../../assets/img/solution/zhlc-2.png'),
    }
  },
  '智慧碳汇': {
    video: require('../../assets/img/solution/zhth.mp4'),
    shorthand: 'SCSS',
    points: [
      require('../../assets/img/solution/points/zhth-1.png'),
      require('../../assets/img/solution/points/zhth-2.png'),
      require('../../assets/img/solution/points/zhth-3.png'),
      require('../../assets/img/solution/points/zhth-4.png'),
    ],
    cases: {
      "某客户碳资产管理大数据平台": require('../../assets/img/solution/zhth-1.png'),
    }
  },
  '智慧环保': {
    video: require('../../assets/img/solution/zhhb.mp4'),
    shorthand: 'SEP',
    points: [
      require('../../assets/img/solution/points/zhhb-1.png'),
      require('../../assets/img/solution/points/zhhb-2.png'),
      require('../../assets/img/solution/points/zhhb-3.png'),
    ],
    cases: {
      "某地区空气监测平台": require('../../assets/img/solution/zhhb-1.png'),
      "某地区水质监测平台": require('../../assets/img/solution/zhhb-2.png'),
      "某地区危固废综合监管平台": require('../../assets/img/solution/zhhb-3.png'),
    }
  },
  '仓储物流': {
    video: require('../../assets/img/solution/ccwl.mp4'),
    shorthand: 'WL',
    points: [
      require('../../assets/img/solution/points/ccwl-1.png'),
      require('../../assets/img/solution/points/ccwl-2.png'),
      require('../../assets/img/solution/points/ccwl-3.png'),
      require('../../assets/img/solution/points/ccwl-4.png'),
    ],
    cases: {
      "某物流数智孪生园区管理系统-华北区": require('../../assets/img/solution/ccwl-1.png'),
      "某物流数智孪生园区管理系统-华南区": require('../../assets/img/solution/ccwl-2.png'),
    }
  },
  '城市治理': {
    video: require('../../assets/img/solution/cszl.mp4'),
    // shorthand: 'Urban Governance',
    shorthand: '',
    points: [
      require('../../assets/img/solution/points/cszl-1.png'),
      require('../../assets/img/solution/points/cszl-2.png'),
      require('../../assets/img/solution/points/cszl-3.png'),
      require('../../assets/img/solution/points/cszl-4.png'),
    ],
    cases: {
      "某部住房城乡建设综合统计平台": require('../../assets/img/solution/cszl-1.png'),
      "某市城市运行管理服务平台": require('../../assets/img/solution/cszl-2.png'),
      "某地区智慧燃气管理平台": require('../../assets/img/solution/cszl-3.png'),
      "某地区数字城管平台": require('../../assets/img/solution/cszl-4.png'),
    }
  },
  '智慧校园': {
    video: require('../../assets/img/solution/zhxy.png'),
    // shorthand: 'Smart Campus',
    shorthand: '',
    points: [
      require('../../assets/img/solution/points/zhxy-1.png'),
      require('../../assets/img/solution/points/zhxy-2.png'),
      require('../../assets/img/solution/points/zhxy-3.png'),
    ],
    cases: {
      "某高中智慧校园管理平台": require('/static/image/home/hyal-6.png'),
    }
  },
  '智慧应急': {
    video: require('../../assets/img/solution/zhyj.mp4'),
    // shorthand: 'Smart Emergency',
    shorthand: '',
    points: [
      require('../../assets/img/solution/points/zhyj-1.png'),
      require('../../assets/img/solution/points/zhyj-2.png'),
      require('../../assets/img/solution/points/zhyj-3.png'),
      require('../../assets/img/solution/points/zhyj-4.png'),
    ],
    cases: {
      "某市辖区智慧应急管理平台": require('../../assets/img/solution/zhyj-1.png'),
    }
  },
  '智慧公安': {
    video: require('../../assets/img/solution/zhga.png'),
    // shorthand: 'Smart Public Security',
    shorthand: '',
    points: [
      require('../../assets/img/solution/points/zhga-1.png'),
      require('../../assets/img/solution/points/zhga-2.png'),
      require('../../assets/img/solution/points/zhga-3.png'),
    ],
    cases: {
      "某市安防小区管控平台": require('../../assets/img/solution/zhga-1.png'),
      "某市县区警务一本通": require('../../assets/img/solution/zhga-2.png'),
    }
  }
}